import { useAuthBearerFetch } from "matsuri-hooks"
import { CleaningExtraInfo, CleaningInfoDetailType } from "@/model/cleaningInfo"
import { m2mCleaning_cleanerV2 } from "@/endpoints/m2m-cleaning.cleaner-v2"
import { m2mCleaning_cleanerV4 } from "@/endpoints/m2m-cleaning.cleaner-v4"

export const useCleaning = (token: string, cleaningId: string | undefined) => {
    return useAuthBearerFetch<CleaningInfoDetailType>(
        token,
        cleaningId ? m2mCleaning_cleanerV2.getCleaning({ cleaningId }) : null,
        {}
    )
}

export const useCleaningExtraInfo = (
    token: string,
    query: {
        cleaningId?: string
        approvalRequestId?: string
    }
) => {
    const params = new URLSearchParams()
    if (query.cleaningId) {
        params.set("cleaningId", query.cleaningId)
    }
    if (query.approvalRequestId) {
        params.set("approvalRequestId", query.approvalRequestId)
    }

    return useAuthBearerFetch<CleaningExtraInfo>(
        token,
        Array.from(params).length > 0
            ? `${m2mCleaning_cleanerV4.getCleaningExtraInfo()}?${params.toString()}`
            : null
    )
}
